module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPrivacyProgress || _vm.isAdmin),
      expression: "showPrivacyProgress || isAdmin"
    }]
  }, [_c('div', {
    staticClass: "graphWrap"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.labelBloodGlucoseProgress')))]), _vm._v(" "), _c('bg-line-graph', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "userId": _vm.$store.state.activeProfile
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "graphWrap"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('message.labelWeightProgress')))]), _vm._v(" "), _c('weight-line-graph', {
    attrs: {
      "userId": _vm.$store.state.activeProfile
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPrivacyProgress && !_vm.isAdmin),
      expression: "!showPrivacyProgress && !isAdmin"
    }]
  }, [_vm._v(_vm._s(_vm.$t('message.labelGraphsPrivate')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6299cab8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/ProfileProgress.vue
// module id = 3752
// module chunks = 1